export class SelectCountry {
    constructor(optionalOptions = {}) {
        this._countryList = document.querySelector('.sheet-column .select-country');

        if (!this._countryList) {
            this.destructor();
            return true;
        }

        this._countryOne = this._countryList.querySelectorAll('li')
        if (!this._countryOne) {
            this.destructor();
            return true;
        }

        let buttonValue
        let selectWrapText
        let countryElement = document.querySelector('[name="country"]')

        if (countryElement) {
            console.log(countryElement)
            console.log(countryElement.closest('.base-input-select--wrp'))
            selectWrapText = countryElement.closest('.base-input-select--wrp').querySelector('.base-input-select--data .base-input-select--choose')
        }

        let thatCountryList = this._countryList

        const removeSelectedMarker = (thatCountryList) => {
            thatCountryList.querySelector('.sheet-column .select-country li.selected').classList.remove('selected');
        }

        this._countryOne.forEach((one) => {
            one.addEventListener("click", () => {
                buttonValue = one.dataset.value

                if (!buttonValue) {
                    return false
                }

                if (one.classList.contains('selected')) {
                    return false
                }

                removeSelectedMarker(thatCountryList)

                one.classList.add('selected')

                if (countryElement) {
                    countryElement.value = buttonValue
                    selectWrapText.innerHTML = one.innerHTML
                }

                document.querySelector('.sheet-overlay').click()
            })
        })
    }

    destructor() {
        this._countryList = null;
        this._countryOne = null;
    }
}

export default new SelectCountry();
